<template lang="pug">
#invoices
    v-toolbar(elevation="2" height="88")
            v-toolbar-title.text-h4.font-weight-bold {{ $t('Menu.__Sales') + ' : ' + $t('Menu.__Invoice') }}
            v-spacer
            v-btn.ml-6(
                rounded,
                color="primary",
                @click="$router.push({ name: 'InvoiceNew' })"
            ) {{ $t('EstimatesAndInvoices.__CreateInvoice') }}
    v-container
        .action-bar.mb-8
            v-row
                v-spacer
                v-col(cols="12" md="3")
                    v-select(
                        v-model="selectedStatus",
                        solo,
                        dense,
                        clearable,
                        outlined,
                        hide-details,
                        :items="statusItems",
                        item-text="text",
                        item-value="key",
                        :placeholder="$t('Placeholder.__Status')"
                    )
                v-col(cols="12" md="3")
                    CustomerSelector(v-model="customer" :insert-tag="false")

                v-col(cols="12" md="3")
                    v-menu(
                        v-model="rangeDateMenu",
                        offset-y,
                        :close-on-content-click="false",
                        :nudge-right="40",
                        transition="scale-transition",
                        min-width="290px"
                    )
                        template(v-slot:activator="{ on }")
                            v-text-field(
                                :value="dateRangeText",
                                clearable,
                                hide-details,
                                solo,
                                dense,
                                outlined,
                                readonly,
                                append-icon="event",
                                v-on="on",
                                :placeholder="$t('Placeholder.__DateRange')",
                                @click:clear="dates = []"
                            )
                        v-date-picker(
                            v-model="dates",
                            @input="rangeDateMenu = dates.length == 2 ? false : true",
                            range,
                            :locale="$store.getters['account/language']() == 'tw'? 'zn-tw': ''"
                        )

        Alert
        ConfirmDialog(
            v-model="deleteDialog",
            :title="$t('EstimatesAndInvoices.__DeleteInvoice')",
            :message="$t('EstimatesAndInvoices.__ConfirmDeleteInvoice')",
            :cancel-text="$t('ActionOption.__Cancel')",
            :confirm-text="$t('ActionOption.__Delete')",
            :confirm-action="deleteInvoice"
        )
        .table-group
            v-tabs
                v-tab(to="#unpaid")
                    span {{ $t('EstimatesAndInvoices.__Unpaid') }}
                    //- v-chip.ml-1(small) {{ unpaidInvoices.length }}
                v-tab(to="#draft")
                    span {{ $t('EstimatesAndInvoices.__Draft') }}
                    //- v-chip.ml-1(small) {{ draftInvoices.length }}
                v-tab(to="#all")
                    span {{ $t('EstimatesAndInvoices.__All') }}
                    //- v-chip.ml-1(small) {{ allInvoices.length }}
            v-divider
            v-data-table.mb-6(:headers="headers", :items="invoices", hide-default-footer :options.sync="options" :loading="loading" :custom-sort="defaultDataSort")
                template(v-slot:item.status="{ item }")
                    v-chip(dark, small, :color="getStatusColor(item.status)") {{ $t('Status.__' + item.status) }}
                template(v-slot:item.name="{ item }") 
                    a(
                        @click="viewItem(item)",
                        style="text-decoration:underline;"
                    ) {{ item.name }}
                template(v-slot:item.number="{ item }") 
                    a(
                        @click="viewItem(item)",
                        style="text-decoration:underline;"
                    ) {{ item.number }}
                template(v-slot:item.customerName="{ item }")
                    span {{ item.customer.name }}
                template(v-slot:item.amount="{ item }")
                    span {{getAmountWithCurrency(item.amount, currencyCode)}}
                template(v-slot:item.unpaidamount="{ item }")
                    span {{getAmountWithCurrency(item.amount - item.paid, currencyCode)}}
                template(v-slot:item.actions="{ item }")
                    //- v-menu(bottom left)
                    //-     template(v-slot:activator="{ on }")
                    //-         v-btn(icon v-on="on")
                    //-             v-icon(small outlined color="primary") arrow_drop_down_circle
                    v-menu(bottom, left)
                        template(v-slot:activator="{ on }")
                            v-btn(icon, v-on="on")
                                v-icon(outlined, color="gray") keyboard_arrow_down
                        v-list
                            template(v-for="(menu, i) in actionItems")
                                v-list-item(
                                    v-if="(item.status != 'Draft' && menu.others == true) || (item.status == 'Draft' && menu.draft == true)",
                                    :key="i",
                                    @click="menu.click(item)"
                                )
                                    v-list-item-title {{ menu.title }}
                                v-divider(v-if="menu.divider")

            v-row.pagination-row
                v-col.d-flex.align-center.justify-start(cols="6")
                    span.mr-2.d-none.d-md-block {{ $t('Table.__ItemsPerPage') }}
                    span
                        v-select.page-select(
                            v-model="options.itemsPerPage",
                            solo,
                            dense,
                            outlined,
                            hide-details,
                            :items="perPageItems"
                        )
                v-col.d-flex.justify-end(cols="6")
                    v-pagination(v-model="options.page", :length="pageCount")

            SharedLinkDialog(
                v-model="sharedDialog",
                :link="sharedLink",
                :title="$t('EstimatesAndInvoices.__ShareInvoice')",
                :message="$t('EstimatesAndInvoices.__ShareInvoiceHint')",
                :confirmText="$t('EstimatesAndInvoices.__CopyLink')"
            )
            SendingEmailDialog(
                v-model="sendEmailDialog",
                :title="$t('EstimatesAndInvoices.__SendInvoice')",
                radioSubtitleKey="EstimatesAndInvoices.__SendInvoiceToCustomer"
                :customer="selectInvoice.customer",
                category="invoice",
                :id="selectInvoice.id"
            )
            RecordInvoicePaymentDialog(
                v-model="recordPaymentDialog",
                :invoice-id="selectInvoice.id",
                :subtitle="$t('EstimatesAndInvoices.__No') + ' #' + selectInvoice.number",
                :amount="selectInvoice.unpaid"
                :confirm-action="recordPayment"
            )
</template>
<script>
import SendingEmailDialog from "@/components/dialogs/SendingEmailDialog"
import SharedLinkDialog from "@/components/dialogs/SharedLinkDialog"
import RecordInvoicePaymentDialog from "@/components/dialogs/RecordInvoicePaymentDialog"

import * as TimeHelper from "@/utils/timeHelper"
import * as PDF from "@/utils/pdf"
import * as currencyHelper from "@/utils/currencies"
import * as datatableHelper from "@/utils/datatableHelper.js"

export default {
  props: ["alert"],
  mixins: [currencyHelper.mixin, TimeHelper.mixin, datatableHelper.mixin],
  components: {
    SendingEmailDialog,
    SharedLinkDialog,
    RecordInvoicePaymentDialog
  },
  data() {
    return {
      perPageItems: [10, 25, 50],
      pageCount: 0,
      options: { page: 1, itemsPerPage: 10, sortBy: [], sortDesc: [] },
      loading: false,
      filters: {},

      deleteDialog: false,
      deleteId: 0,
      sharedDialog: false,
      sharedLink: "",
      sendEmailDialog: false,
      recordPaymentDialog: false,
      selectInvoice: {},
      selectedStatus: null,
      statusItems: [
        {
          text: this.$t("Status.__Draft"),
          color: "#dcdcdc",
          key: "Draft"
        },
        {
          text: this.$t("Status.__Unsent"),
          color: "#505356",
          key: "Unsent"
        },
        {
          text: this.$t("Status.__Sent"),
          color: "#14c8c8",
          key: "Sent"
        },
        {
          text: this.$t("Status.__Partial"),
          color: "#b3e87f",
          key: "Partial"
        },
        {
          text: this.$t("Status.__Paid"),
          color: "#8cdc3c",
          key: "Paid"
        },
        {
          text: this.$t("Status.__Viewed"),
          color: "primary",
          key: "Viewed"
        },
        {
          text: this.$t("Status.__Expired"),
          color: "#e6465a",
          key: "Expired"
        }
      ],
      customer: null,
      actionItems: [
        {
          title: this.$t("EstimatesAndInvoices.__Approve"),
          click: this.approveItem,
          draft: true,
          others: false
        },
        {
          title: this.$t("ActionOption.__View"),
          click: this.viewItem,
          draft: true,
          others: true
        },
        {
          title: this.$t("EstimatesAndInvoices.__Edit"),
          click: this.editItem,
          draft: true,
          others: true
        },
        {
          title: this.$t("ActionOption.__Duplicate"),
          click: this.duplicateInvoice,
          divider: true,
          draft: true,
          others: true
        },

        {
          title: this.$t("EstimatesAndInvoices.__RecordPaymentReceived"),
          click: item => {
            this.recordPaymentDialog = true
            this.selectInvoice = item
          },
          draft: false,
          others: true
        },
        {
          title: this.$t("EstimatesAndInvoices.__SendVia2SUMUP"),
          click: this.sendEmail,
          draft: false,
          others: true
        },
        {
          title: this.$t("EstimatesAndInvoices.__GetLink"),
          click: this.shareLink,
          draft: false,
          others: true
        },
        {
          title: this.$t("ActionOption.__ExportPDF"),
          click: this.downloadPDF,
          draft: true,
          others: true
        },
        {
          title: this.$t("ActionOption.__Print"),
          divider: true,
          click: this.printItem,
          draft: true,
          others: true
        },
        {
          title: this.$t("ActionOption.__Delete"),
          click: this.deleteItem,
          draft: true,
          others: true
        }
      ],
      rangeDateMenu: false,
      dates: [],
      searchText: "",
      headers: [
        {
          text: this.$t("EstimatesAndInvoices.__Status"),
          align: "start",
          sortable: true,
          value: "status"
        },
        {
          text: this.$t("EstimatesAndInvoices.__Title"),
          align: "start",
          sortable: true,
          value: "name"
        },
        {
          text: this.$t("EstimatesAndInvoices.__InvoiceDate"),
          align: "start",
          sortable: true,
          value: "issuedAt"
        },
        {
          text: this.$t("EstimatesAndInvoices.__No"),
          align: "start",
          sortable: true,
          value: "number"
        },
        {
          text: this.$t("EstimatesAndInvoices.__Customer"),
          align: "start",
          sortable: true,
          value: "customerName"
        },
        {
          text: this.$t("EstimatesAndInvoices.__InvoiceAmountInList"),
          align: "end",
          sortable: true,
          value: "amount"
        },
        {
          text: this.$t("EstimatesAndInvoices.__OutstandingPayment"),
          align: "end",
          sortable: true,
          value: "unpaidamount"
        },
        {
          text: "",
          align: "center",
          sortable: false,
          value: "actions"
        }
      ],
      allInvoices: [],
      unpaidInvoices: [],
      draftInvoices: [],
      invoices: [],
      filteredInvoices: []
    }
  },
  watch: {
    dates(value) {
      if (this.dates.length > 0) {
        this.filters.from = this.dates[0]
        this.filters.to = this.dates.length == 2 ? this.dates[1] : this.dates[0]
      } else {
        delete this.filters["from"]
        delete this.filters["to"]
      }
      this.getInvoices()
    },
    customer(value) {
      if (this.customer) {
        this.filters.customerId = this.customer.id
      } else {
        delete this.filters["customerId"]
      }

      this.getInvoices()
    },
    urlHash(value) {
      if (value == "#draft") {
        this.selectedStatus = "Draft"
      } else if (value == "#all") {
        this.selectedStatus = null
      } else {
        this.selectedStatus = "Unpaid"
      }
    },
    selectedStatus(value) {
      if (this.selectedStatus) {
        this.filters.status = this.selectedStatus
        this.getInvoices()
      } else {
        this.getTabInvoices()
      }
    },
    options: {
      handler() {
        this.getTabInvoices()
      },
      deep: true
    }
  },
  methods: {
    // filterInvoices() {
    //     this.filteredInvoices = this.invoices
    //     this.filteredInvoices = this.filteredInvoices.filter(item => {
    //         return this.selectedStatus == null
    //             ? true
    //             : item.status == this.selectedStatus
    //     })
    //     this.filteredInvoices = this.filteredInvoices.filter(item => {
    //         return this.customer == null
    //             ? true
    //             : item.customer.id == this.customer.id
    //     })
    //     this.filteredInvoices = this.filteredInvoices.filter(item => {
    //         if (this.dates.length == 0) return true
    //         var dates = this.dates.slice().sort()
    //         var issuedAtTimestamp = this.date2unixtimestamp(item.issuedAt)
    //         var date1Timestamp = this.date2unixtimestamp(dates[0])
    //         var date2Timestamp = dates[1]
    //             ? this.date2unixtimestamp(dates[1])
    //             : 0
    //         return this.dates.length == 1
    //             ? issuedAtTimestamp == date1Timestamp
    //             : issuedAtTimestamp >= date1Timestamp &&
    //                   issuedAtTimestamp <= date2Timestamp
    //     })
    // },
    // showTabInvoices() {
    //     if (this.urlHash == "#unpaid") {
    //         this.filteredInvoices = this.invoices = this.unpaidInvoices
    //     } else if (this.urlHash == "#draft") {
    //         this.filteredInvoices = this.invoices = this.draftInvoices
    //     } else if (this.urlHash == "#all") {
    //         this.filteredInvoices = this.invoices = this.allInvoices
    //     }
    //     this.filterInvoices()
    // },
    getTabInvoices() {
      if (!this.selectedStatus) {
        if (this.urlHash == "#draft") {
          this.selectedStatus = "Draft"
        } else if (this.urlHash == "#unpaid") {
          this.selectedStatus = "Unpaid"
        } else {
          delete this.filters["status"]
          this.selectedStatus = null
          this.getInvoices()
        }
      } else {
        this.getInvoices()
      }
      //     this.unpaidInvoices = this.allInvoices.filter(invoice => {
      //         if (invoice.status == "Draft" || invoice.status == "Paid") {
      //             return false
      //         }
      //         return true
      //     })

      //     this.draftInvoices = this.allInvoices.filter(invoice => {
      //         if (invoice.status == "Draft") {
      //             return true
      //         }
      //         return false
      //     })

      //     this.showTabInvoices()
    },
    getInvoices() {
      var query = this.datatableOptionsToQuery(this.options)
      query = Object.assign({}, query, this.filters)
      this.loading = true
      // this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("invoices/getInvoices", query)
        .then(
          function(response) {
            this.invoices = response.data
            this.pageCount = response.paging.totalPages
            this.loading = false
            // this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(
          function(error) {
            this.loading = false
            // this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    printItem(item) {
      var id = item.id
      this.$router.push({
        name: "InvoiceExport",
        params: {
          invoiceId: id,
          exportType: "print"
        }
      })
    },
    editItem(item) {
      var id = item.id
      this.$router.push({
        name: "InvoiceEdit",
        params: {
          id: id
        }
      })
    },
    viewItem(item) {
      var id = item.id
      this.$router.push({
        name: "InvoiceView",
        params: {
          id: id
        }
      })
    },
    deleteItem(item) {
      this.deleteDialog = true
      this.deleteId = item.id
    },
    approveItem(item) {
      this.$store
        .dispatch("invoices/approveInvoice", item.id)
        .then(
          function(response) {
            this.$store.dispatch("global/stopLoading")
            this.getInvoices()
            // this.$store.dispatch(
            //     "global/showAlertSuccess",
            //     this.$t("已核准請款成功.")
            // )
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
    },
    sendEmail(item) {
      this.selectInvoice = item
      this.sendEmailDialog = true
    },
    duplicateInvoice(item) {
      this.$store
        .dispatch("invoices/duplicateInvoice", item.id)
        .then(
          function(response) {
            this.$store.dispatch("global/stopLoading")
            this.getInvoices()
            this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullyDuplicated"))
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
    },
    shareLink(item) {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("invoices/shareInvoice", item.id)
        .then(
          function(response) {
            var token = response.data.token
            this.sharedLink = process.env.VUE_APP_DOMAIN + "share/invoices/" + token

            this.sharedDialog = true

            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(function(error) {}.bind(this))
    },
    deleteInvoice() {
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("invoices/deleteInvoice", this.deleteId)
        .then(
          function(response) {
            this.getInvoices()
            this.$store.dispatch("global/showAlertSuccess", this.$t("Messages.__SuccessfullyDeleted"))
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/showAlertError", error.message)
          }.bind(this)
        )
      this.deleteDialog = false
    },
    downloadPDF(item) {
      // this.$store.dispatch("global/startLoading")
      var id = item.id
      this.$router.push({
        name: "InvoiceExport",
        params: {
          invoiceId: id,
          exportType: "download"
        }
      })
    },
    recordPayment() {
      this.getInvoices()
    },
    getStatusColor(status) {
      for (var item of this.statusItems) {
        if (item.key == status) {
          return item.color
        }
      }
    }
  },
  computed: {
    dateRangeText() {
      return this.dates
        .slice()
        .sort()
        .join(" ~ ")
    },
    customers() {
      return this.invoices.map(function(invoice) {
        return { id: invoice.customer.id, name: invoice.customer.name }
      })
    },
    urlHash() {
      return this.$route.hash || "#unpaid"
    }
  },
  mounted() {
    if (this.alert) {
      this.$store.dispatch("global/showAlert", this.alert)
    }
  },
  created() {}
}
</script>
<style lang="scss" scoped>
.page-select {
  width: 80px;
}
.sumary-card {
  color: #505356;
  .sumary-card-title {
    font-family: NotoSansCJKtc;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.57;
    letter-spacing: normal;
    margin-bottom: 16px;
  }
  .sumary-card-content {
    .remark {
      margin-left: 8px;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.57;
      letter-spacing: normal;
      color: #b4b9be;
    }
    font-family: NotoSansCJKtc;
    font-size: 23px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.22;
    letter-spacing: normal;
    margin-bottom: 16px;
  }
  .sumary-card-description {
    opacity: 0.66;
    font-family: NotoSansCJKtc;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: normal;
  }
}
</style>
